import { module } from 'angular';
import { CgIconDirective } from './directives/cg-icon';
import { MSIEDirective } from './directives/msie';
import { LightboxService } from './services/lightbox';
import { LocationService } from './services/location-service';
import { PromptMessageService } from './services/prompt-message';
import '../scss/_master.scss';
export var ngModule = module('gn.audio.cg.theming', [])
    .directive('cgIcon', CgIconDirective)
    .directive('msie', MSIEDirective)
    .service('lightbox', LightboxService)
    .service('locationService', LocationService)
    .service('promptMessage', PromptMessageService);
